/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MapComponent } from './containers';
import { PlaceByQueryParamResolver } from './services/resolver/place-resolver';

export const MAPS_ROUTES_MODULE: ModuleWithProviders<RouterModule> = RouterModule.forChild([
  { path: '', component: MapComponent },
  {
    path: 'editPlace',
    component: MapComponent,
    resolve: { placeData: PlaceByQueryParamResolver }
  },
  { path: 'map', redirectTo: '' } // TODO: remove this when we have the proper solution on the legacy redirection after login
]);
